import React, {useEffect, useState} from 'react'
import { Alphabet } from './../utils/constants';

const Decode = (props) => {
    const text = props.text.replace(/\s/g, '');
    const secretCode = props.secretCode.replace(/ /g, '_');
    const [decodedMessage, setDecodedMessage] = useState(" ");
    const filterContent = (text) => {
        let cleaned = text.replace(/<\s*script\b[^>]*>.*?<\s*\/\s*script\s*>/gmi, '');
        cleaned = cleaned.replace(/on\w+\s*=\s*['"][^'"]*['"]/gmi, ''); 
        return cleaned
    };
    const numAlph = {};
    for(let i=0; i<Alphabet.length; i++) {
        numAlph[Alphabet[i]] = i;
    }

    useEffect(() => {
        let contentToDisplay = '';
        if (secretCode) {
            try {
                 for (let i = 0; i < text.length; i++) {
                    contentToDisplay += Alphabet[(numAlph[text[i]] - numAlph[secretCode[i % secretCode.length]] + Alphabet.length) % Alphabet.length];
                }
            } catch (e) {
                console.error("Decryption failed:", e);
                contentToDisplay = "Decryption Error";
            }
        } else {
            contentToDisplay = text; 
        }
        let safeContent = filterContent(contentToDisplay);
        safeContent = safeContent.replace(/>/g, ' ');
        setDecodedMessage(safeContent);
        props.setDecodedMessage(safeContent);
    }, [text, secretCode]);

    return (
        <div className={`message-bubble updateInput ${props.isVanishing ? 'dust-particle-effect' : ''}`}  >{decodedMessage} </div>
    )
}
export default Decode
